import { render, staticRenderFns } from "./BlockWidthCustoms.vue?vue&type=template&id=743d0ceb"
import script from "./BlockWidthCustoms.vue?vue&type=script&lang=js"
export * from "./BlockWidthCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports